import type { ReactNode } from 'react';
import { Box, Stack } from '@mui/material';

const GAP = { xs: 1.5, md: 2 };

/** The main content, and a column of small panels (`side`). On a very wide screen the panels sit beside it; otherwise below. */
export function WithSideColumn({ children, side }: { children: ReactNode; side: ReactNode }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gap: GAP,
        gridTemplateColumns: { xs: 'minmax(0, 1fr)', xl: 'minmax(0, 1fr) 340px' },
        alignItems: 'start',
      }}
    >
      <Stack spacing={GAP} sx={{ minWidth: 0 }}>
        {children}
      </Stack>
      <Box
        sx={{
          display: 'grid',
          gap: GAP,
          alignContent: 'start',
          gridTemplateColumns: { xs: 'repeat(auto-fit, minmax(min(100%, 320px), 1fr))', xl: 'minmax(0, 1fr)' },
        }}
      >
        {side}
      </Box>
    </Box>
  );
}
